import { z } from 'zod';
import { msg } from '@/lib/forms/messages';
import { maxCodePoints } from '@/lib/forms/primitives';

// Mirrors 017_drbfm_tables.sql:16 item_name VARCHAR(500) + :31 CHECK (LENGTH(item_name) <= 500),
// measured RAW and in code points: useStagedWorkflow's createSession posts the state string as typed.
export const stagedWorkflowStartSchema = z.object({
  // Capped raw (that is what posts), required trimmed.
  itemName: z
    .string()
    .check(maxCodePoints(500, 'validation.maxLength'))
    .refine((value) => value.trim().length > 0, msg('validation.required')),
});
